module.exports = __webpack_public_path__ + "static/media/reality2.b2009cbc.jpg";